import React from 'react';
import { Eye } from 'lucide-react';

const COPY = {
  en: {
    descriptor: 'Digital Transformation Consulting for workforce-driven and service-based businesses.',
    location: 'Nashville, TN · Bilingual by design',
    copyright: (year) => `© ${year} illumi.dev · Systems with intention.`,
    contact: 'Contact',
    admin_access: 'Admin access',
  },
  es: {
    descriptor: 'Consultoría de Transformación Digital para negocios impulsados por su equipo y de servicios.',
    location: 'Nashville, TN · Bilingüe por diseño',
    copyright: (year) => `© ${year} illumi.dev · Sistemas con intención.`,
    contact: 'Contacto',
    admin_access: 'Acceso de administrador',
  },
};

const FooterV2 = ({ language = 'en', buildHref }) => {
  const t = COPY[language] || COPY.en;
  const year = new Date().getFullYear();
  const href = (target) => (typeof buildHref === 'function' ? buildHref(target) : target);
  return (
    <footer className="iv2-footer" data-testid="iv2-footer">
      <div className="iv2-container iv2-footer-inner">
        <div className="iv2-footer-left">
          <a href={href('/')} className="iv2-logo" data-testid="iv2-footer-logo">
            <span>illumi</span><span className="iv2-logo-accent">.dev</span>
          </a>
          <p className="iv2-footer-descriptor">{t.descriptor}</p>
        </div>
        <div className="iv2-footer-right">
          <p className="iv2-footer-line">{t.location}</p>
          <p className="iv2-footer-line iv2-footer-copy">{t.copyright(year)}</p>
          <p className="iv2-footer-line">
            <a href={href('/v2/contact')} className="iv2-footer-link" data-testid="iv2-footer-contact-link">
              {t.contact}
            </a>
          </p>
        </div>
      </div>
      <a
        href="/admin/login"
        className="iv2-footer-admin-eye"
        aria-label={t.admin_access}
        title={t.admin_access}
        data-testid="iv2-footer-admin-eye-link"
      >
        <Eye size={16} aria-hidden="true" />
      </a>
    </footer>
  );
};

export default FooterV2;
